import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4baae05c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "info__object__container" }
const _hoisted_3 = { class: "info__object" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info__object__paragraph" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "info__object__paragraph_strong" }, "SINC"),
  /*#__PURE__*/_createTextVNode(" - Sistema de Informações para Controle ")
], -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "info__object__container" }
const _hoisted_8 = { class: "info__object" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info__object__paragraph" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "info__object__paragraph_strong" }, "SINC"),
  /*#__PURE__*/_createTextVNode(" - Sistema de Informações para Controle ")
], -1))

import computerlink from '../static/icon_sinc_folha.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoSinc',
  props: {
  showInfo: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.showInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(computerlink),
              class: "info__object__icon"
            }, null, 8, _hoisted_4),
            _hoisted_5
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              src: _unref(computerlink),
              class: "info__object__icon"
            }, null, 8, _hoisted_9),
            _hoisted_10
          ])
        ])
      ]))
}
}

})